import { FetchError } from "../errors/FetchError";
import { fetchWithAuthorization } from "./fetch";

const withSearch = (url, search) => {
  const term = typeof search === "string" ? search.trim() : "";
  if (!term) return url;
  return `${url}&search=${encodeURIComponent(term)}`;
};

export const fetchBanks = async (page, limit = 10, params) => {
  const { search } = params;

  try {
    let url = `/bank?page=${page}&limit=${limit}`;

    url = withSearch(url, search);

    const data = await fetchWithAuthorization(url);

    return data;
  } catch (error) {
    throw new FetchError(error, "This is a custom error in FetchBanks");
  }
};

export const fetchCondominiumBanks = async (page, limit = 10, params) => {
  const { condominiumId, search } = params;

  if (!condominiumId) {
    // per_page devuelve el limit pedido y no un 10 fijo, por el mismo motivo
    // que en fetchDebtsToPayAsPropertyCuentaPending: los hooks de paginacion
    // adoptan el per_page de la respuesta, asi que un valor fijo aca le pisa el
    // tamaño de pagina a quien pidio otro.
    return { data: [], meta: { current_page: 1, last_page: 1, total: 0, per_page: limit } };
  }
  try {
    let url = `/bank/search/all?page=${page}&limit=${limit}&condominium_id=${condominiumId}`;
    url = withSearch(url, search);
    const data = await fetchWithAuthorization(url);
    return data;
  } catch (error) {
    throw new FetchError(error, "This is a custom error in FetchBanks");
  }
};

export const fetchCondominiumBanksAll = async (params) => {
  const { condominiumId, search } = params;
  try {
    let url = `/bank/search/all?condominium_id=${condominiumId}`;
    url = withSearch(url, search);

    // Realizar la solicitud
    const data = await fetchWithAuthorization(url);
    return data;
  } catch (error) {
    throw new FetchError(error, "This is a custom error in FetchBanks");
  }
};

export const fetchPublicBanks = async (page, limit = 10, params) => {
  try {
    const { search } = params;
    let url = `/public/banks?page=${page}&limit=${limit}`;
    url = withSearch(url, search);
    const data = await fetchWithAuthorization(url);
    return data;
  } catch (error) {
    throw new FetchError(error, "This is a custom error in FetchBanks");
  }
};

export const fetchMyBanks = async (page, limit = 10, params) => {
  try {
    const { search } = params;
    let url = `/bank?page=${page}&limit=${limit}`;
    url = withSearch(url, search);
    const data = await fetchWithAuthorization(url);
    return data;
  } catch (error) {
    throw new FetchError(error, "This is a custom error in FetchBanks");
  }
};

export const create = async (bankDto) => {
  try {
    const data = await fetchWithAuthorization("/bank", bankDto, "POST");
    return data;
  } catch (error) {
    throw new FetchError(error, "Http call to Create bank failed");
  }
};

export const update = async (bankid, bankDto) => {
  try {
    const data = await fetchWithAuthorization(
      `/bank/${bankid}`,
      bankDto,
      "PUT"
    );
    return data;
  } catch (error) {
    throw new FetchError(error, "Http call to Create bank failed");
  }
};

export const findOne = async (bankId, signal) => {
  try {
    const data = await fetchWithAuthorization(`/bank/${bankId}`, signal, "GET");
    return data;
  } catch (error) {
    throw new FetchError(error, "Http call to Find bank failed");
  }
};

export const remove = async (id) => {
  try {
    const data = await fetchWithAuthorization(`/bank/${id}`, null, "DELETE");
    return data;
  } catch (error) {
    throw new FetchError(error, "Http call to RemoveCondominium failed");
  }
};

export const removeBankRoot = async (id) => {
  try {
    const data = await fetchWithAuthorization(
      `/bank/delete/${id}`,
      null,
      "DELETE"
    );
    return data;
  } catch (error) {
    throw new FetchError(error, "Http call to RemoveCondominium failed");
  }
};
export const addBalance = async (bankId, datas) => {
  try {
    const data = await fetchWithAuthorization(
      `/bank/add-balance/${bankId}`,
      datas,
      "POST"
    );
    return data;
  } catch (error) {
    throw new FetchError(error, "Http call to add balance failed");
  }
};
